/* Styling */
import './app.css';

/* Modules */
import { initBackgroundChange } from '$src/js/modules/navigation/background-change';
import { initHamburger } from '$src/js/modules/navigation/hamburger';
import { activeNavigation } from '$src/js/modules/navigation/active-navigation';
import { videoPopup } from '$src/js/modules/video-popup/init-video-popup';
import { initBouncerValidation } from '$src/js/modules/form-validation/init-bouncer';
import { marqueePartners } from '$src/js/modules/partners/marquee';
import { horizontalScroll } from '$src/js/modules/ui/horizontal-scroll';
import { initShareComponent } from '$src/js/modules/share/share';
import { initImageSlider } from '$src/js/modules/slider/slider';
import { initCalendar } from '$src/js/modules/calendar/init';
import { initActivityTabs } from '$src/js/modules/activity-tabs/activity-tabs';
import { initParticipants } from '$src/js/modules/participants/init';
import { initNewsletterSubmission } from '$src/js/modules/newsletter/submission';
import { initRequestActivity } from '$src/js/modules/request-activity/init';
import { initParticipateEvent } from '$src/js/modules/participate-event/init';
import { initMyEventList, initModifyEvent } from '$src/js/modules/profile/my-events/init';
import { initMySubmissions } from '$src/js/modules/profile/submissions/init';
import { initAccordionItems } from '$src/js/modules/accordion-items/accordion-items';
import { manageSubmissions } from '$js/modules/profile/submissions/manage-submissions';

videoPopup();
initBackgroundChange();
initHamburger();
activeNavigation();
initBouncerValidation();
marqueePartners();
horizontalScroll();
initShareComponent();
initImageSlider();
initCalendar();
initActivityTabs();
initParticipants();
initRequestActivity();
initNewsletterSubmission();
initParticipateEvent();
initMyEventList();
initModifyEvent();
initMySubmissions();
initAccordionItems();
manageSubmissions();
